import {makeSystemModePath} from './shared/serverFunctions';

/**
 * Sales Summary
 *      All, Filters
 *      by: Location, DBA, District, State
 *      by: State & City, State & DBA
 * Bihourly
 *      All
 *      by: Location, DBA, District, State
 *      by: State & City, State & DBA
 */
export const RESOURCES = {
    "SalesSummaryAll": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary (All)",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumbyDateRange/" + startEndOffset
            }
        }
    },
    "SalesSummaryAllTotals": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Totals (All)",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/paymentSumByDateRange/" + startEndOffset
            }
        }
    },
    "SalesSummaryByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by Location",
                "uri": localStorage.getItem('server') + "/api/v5/report/sale/" + systemMode + "/" + params.location_id + "/salesSumbyLocDateRange/" + startEndOffset
            }
        }
    },
    "SalesSummaryTotalsByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Totals by Location",
                "uri": localStorage.getItem('server') + "/api/v5/report/payment/" + systemMode + "/" + params.location_id + "/paymentSumByLocDateRange/" + startEndOffset
            }
        }
    },
    "SalesSummaryByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumbyDBADateRange/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryTotalsByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/paymentSumByDBADateRange/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by District",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumbyDistrictDateRange/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryTotalsByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by District",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/paymentSumByDistDateRange/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by State",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumbyStateDateRange/" + params.state + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryTotalsByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by State",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/paymentSumByStateDateRange/" + params.state + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by City and State",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumbyCityStateDateRange/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryTotalsByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by City and State",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/paymentSumByStCityDateRange/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryByStateDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by City and DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/salesSumbyDBAStateDateRange/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryTotalsByStateDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary by City and DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/paymentSumByStDBADateRange/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryBihourlyAll": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Bihourly (All)",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/hourlyByDateRange/" + startEndOffset
            }
        }
    },
    "SalesSummaryHourlyByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Bihourly (by Location)",
                "uri": localStorage.getItem('server') + "/api/v5/report/payment/" + systemMode + "/" + params.location_id + "/hourlyByLocDateRange/" + startEndOffset
            }
        }
    },
    "SalesSummaryHourlyByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Bihourly (by DBA)",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/hourlyByDBADateRange/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryHourlyByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Bihourly (by District)",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/hourlyByDistDateRange/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryHourlyByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Bihourly (by State)",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/hourlyByStateDateRange/" + params.state + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryHourlyByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Bihourly (by State and City)",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/hourlyByStCityDateRange/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "SalesSummaryHourlyByStateDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Sales Summary Bihourly (by State and DBA)",
                "uri": localStorage.getItem('server') + "/api/v5/report/payments/" + systemMode + "/hourlyByStDBADateRange/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "SalesSummaryByState"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseSalesSummaryReportsResourceMap.js